@if (showAddButton) {
  <label class="documents__add" [class.documents__add--loading]="loading">
    <input
      class="documents__input"
      type="file"
      accept=".jpg, .pdf, .jpeg, .png"
      [disabled]="loading"
      (change)="addFile($event)"
    />
    <i class="documents__icon documents__icon--add" aria-hidden="true"></i>
    <span class="documents__label">Adicionar</span>
  </label>
}

@for (document of documents ?? []; track document.pk ?? $index; let index = $index) {
  <button
    class="documents__item"
    type="button"
    [class.documents__item--selected]="index === selectedIndex()"
    [attr.aria-pressed]="index === selectedIndex()"
    (click)="select(index)"
  >
    <i class="documents__icon documents__icon--file" aria-hidden="true"></i>
    <span class="documents__label">{{ document.filename }}</span>
  </button>
}
